<template>
  <GroupMasterLayout>
    <div class="profile__section__outer_wrapper">
      <div class="account__header__banner">
        <div
          class="account_settings_banner co_dealer_details"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31, 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="banner__text_section">
            <h3 class="banner__text">
              {{ $t("text.cusProfile.accountSettings") }}
            </h3>
          </div>
        </div>
        <div class="account_Settings_profile_details_section_row">
          <div class="account_Settings_profile_details_section_first_row">
            <img src="@/assets/img/profile_pic.png" class="profile__pic" />
          </div>
          <div class="account_Settings_profile_details_section_second_row">
            <h5 class="profile__detail__header mt-2">
              {{ userName }} <br />
              <small>{{ userDetails.email }}</small>
            </h5>
          </div>
        </div>
      </div>
      <div class="account_Settings_profile_details_section">
        <div class="profile__form_section">
          <div class="row">
            <div class="col-md-6 profile__edit_form_section">
              <div class="row profile__form_section__row mt-5" ref="email_div">
                <div class="col-md-10 profile__input">
                  <h6>
                    <input
                      type="text"
                      :placeholder="$t('text.cusProfile.email')"
                      v-model="email"
                      @input="captureEvents($event)"
                      :disabled="emailDisabled ? true : null"
                    />
                    <!-- <span class="mobile_pencil_icon">
                      <img
                        src="@/assets/img/pencil-3.png"
                        width="25px"
                        style="cursor: pointer, display:none"
                        @click="activateEamilInput"
                      />
                    </span> -->
                  </h6>
                </div>
                <!-- <div class="col-md-6 profile__input__header">
                                    <h3>{{userDetails.email.substring(0, 20)}}</h3>
                                </div> -->
                <!-- <div class="col-md-2">
                  <img
                    src="@/assets/img/pencil-3.png"
                    width="25px"
                    style="cursor: pointer"
                    @click="activateEamilInput"
                    class="web_pencil_icon"
                  />
                </div> -->
              </div>
              <div ref="email_error"></div>
              <div class="row profile__form_section__row mt-5" ref="fn_div">
                <div class="col-md-10 profile__input">
                  <h6>
                    <input
                      type="text"
                      :placeholder="$t('text.cusProfile.firstName')"
                      v-model="firstName"
                      @input="captureEvents($event)"
                      @click="activateFNInput"
                      :disabled="fnDisabled ? true : null"
                    />
                    <span class="mobile_pencil_icon">
                      <img
                        src="@/assets/img/pencil-3.png"
                        width="25px"
                        style="cursor: pointer, display:none"
                        @click="activateFNInput"
                      />
                    </span>
                  </h6>
                </div>
                <!-- <div class="col-md-6 profile__input__header">
                                        <h3>{{userDetails.firstName}}</h3>
                                    </div> -->
                <div class="col-md-2">
                  <img
                    src="@/assets/img/pencil-3.png"
                    width="25px"
                    style="cursor: pointer"
                    @click="activateFNInput"
                    class="web_pencil_icon"
                  />
                </div>
              </div>
              <div ref="fn_error"></div>
              <div class="row profile__form_section__row mt-5" ref="ln_error">
                <div class="col-md-10 profile__input">
                  <h6>
                    <input
                      type="text"
                      :placeholder="$t('text.cusProfile.lastName')"
                      v-model="lastName"
                      @input="captureEvents($event)"
                      :disabled="lnDisabled ? true : null"
                    />
                    <span>
                      <img
                        src="@/assets/img/pencil-3.png"
                        width="25px"
                        style="cursor: pointer, display:none"
                        @click="activateLNInput"
                        class="mobile_pencil_icon"
                      />
                    </span>
                  </h6>
                </div>
                <!-- <div class="col-md-6 profile__input__header">
                                    <h3>{{userDetails.lastName}}</h3>
                                </div> -->
                <div class="col-md-2">
                  <img
                    src="@/assets/img/pencil-3.png"
                    width="25px"
                    style="cursor: pointer"
                    @click="activateLNInput"
                    class="web_pencil_icon"
                  />
                </div>
              </div>
              <div ref="ln_error"></div>
              <div class="row profile__form_section__row mt-5" ref="phone_div">
                <div class="col-md-10 profile__input">
                  <h6>
                    <input
                      type="text"
                      :placeholder="$t('text.cusProfile.phoneNumber')"
                      v-model="phone"
                      @input="captureEvents($event)"
                      :disabled="phoneDisabled ? true : null"
                    />
                    <span class="mobile_pencil_icon">
                      <img
                        src="@/assets/img/pencil-3.png"
                        width="25px"
                        style="cursor: pointer, display:none"
                        @click="activatePhoneInput"
                      />
                    </span>
                  </h6>
                </div>
                <!-- <div class="col-md-6 profile__input__header">
                                    <h3>{{userDetails.phone}}</h3>
                                </div> -->
                <div class="col-md-2">
                  <img
                    src="@/assets/img/pencil-3.png"
                    width="25px"
                    style="cursor: pointer"
                    @click="activatePhoneInput"
                    class="web_pencil_icon"
                  />
                </div>
              </div>
              <div ref="phone_error"></div>
              <div class="edit_profile_button mt-3 text-center">
                <button
                  class="save__btn record_expense_btn other_btn_4"
                  @click="editForm($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.cusProfile.editProfile") }} <span></span>
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 edit_loader"
                />
              </div>
            </div>
            <div class="col-md-6 left-section change_password__form__section">
              <transition name="" mode="out-in" appear>
                <section class="profile__change_password_form_section">
                  <div>
                    <transition name="fade" mode="out-in" appear>
                      <h6 class="login_header text-center">
                        {{ $t("text.cusProfile.changeYourPassword") }}
                      </h6>
                    </transition>
                  </div>
                  <div class="form_section mt-3">
                    <form>
                      <div class="form_input_section mt-3">
                        <!-- <div class="input__div" ref="old_password_input_div">
                          <div class="placeholder_div">
                            <img
                              src="@/assets/img/lock.png"
                              width="20px"
                              class="input_placeholder_icon"
                            />
                          </div>
                          <div class="input_field_section">
                            <input
                              type="password"
                              placeholder="Old Password"
                              v-model="oldPassword"
                              @input="captureFormEvents($event)"
                            />
                          </div>
                        </div> -->
                        <div class="input__block" ref="old_password_input_div">
                          <input
                            type="password"
                            :placeholder="$t('text.cusProfile.oldPassword')"
                            class="form-control"
                            @blur="captureFormEvents($event)"
                            v-model="oldPassword"
                          />
                        </div>
                        <div ref="old_password_error_message"></div>
                      </div>
                      <div class="form_input_section mt-4">
                        <!-- <div class="input__div" ref="new_password_input_div">
                          <div class="placeholder_div">
                            <img
                              src="@/assets/img/lock.png"
                              width="20px"
                              class="input_placeholder_icon"
                            />
                          </div>
                          <div class="input_field_section">
                            <input
                              type="password"
                              placeholder="New Password"
                              v-model="newPassword"
                              @input="captureFormEvents($event)"
                            />
                          </div>
                        </div> -->
                        <div class="input__block" ref="new_password_input_div">
                          <input
                            type="password"
                            :placeholder="$t('text.cusProfile.newPassword')"
                            class="form-control"
                            @blur="captureFormEvents($event)"
                            v-model="newPassword"
                          />
                        </div>
                        <div ref="new_password_error_message"></div>
                        <div
                          ref="invalid_password_format"
                          class="password_error"
                        >
                          <p>{{ $t("text.cusProfile.passwordMustContain") }}</p>
                          <ul>
                            <li>{{ $t("text.cusProfile.oneNumeric") }}</li>
                            <li>
                              {{ $t("text.cusProfile.specialCharacter") }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="form_input_section mt-4">
                        <!-- <div
                          class="input__div"
                          ref="confirm_password_input_div"
                        >
                          <div class="placeholder_div">
                            <img
                              src="@/assets/img/lock.png"
                              width="20px"
                              class="input_placeholder_icon"
                            />
                          </div>
                          <div class="input_field_section">
                            <input
                              type="password"
                              placeholder="Confirm Password"
                              v-model="confirmPassword"
                              @input="captureFormEvents($event)"
                            />
                          </div>
                        </div> -->
                        <div
                          class="input__block"
                          ref="confirm_password_input_div"
                        >
                          <input
                            type="password"
                            :placeholder="$t('text.cusProfile.confirmPassword')"
                            class="form-control"
                            @blur="captureFormEvents($event)"
                            v-model="confirmPassword"
                          />
                        </div>
                        <div ref="confirm_password_error_message"></div>
                        <!-- <div
                          ref="invalid_password_format"
                          class="password_error"
                        >
                          <p>{{$t('text.cusProfile.passwordMustContain')}}</p>
                          <ul>
                            <li>{{$t('text.cusProfile.oneNumeric')}}</li>
                            <li>O{{$t('text.cusProfile.specialCharacter')}}</li>
                          </ul>
                        </div> -->
                      </div>
                      <div class="text-center mt-3">
                        <div class="text-center pay_btn_section">
                          <button
                            class="save__btn record_expense_btn other_btn_4"
                            type="submit"
                            @click="validateResetForm"
                            :disabled="isButtonDisabled ? true : null"
                            :style="[
                              isButtonDisabled
                                ? { cursor: 'not-allowed' }
                                : { cursor: 'pointer' },
                            ]"
                          >
                            {{ $t("text.cusProfile.changePassword") }}
                            <span></span>
                          </button>
                          <img
                            src="@/assets/img/git_loader.gif"
                            style="display: none"
                            width="35px"
                            class="ml-3 changePassword"
                          />
                        </div>
                        <!-- <button type="submit" class="btn btn-primary submit_btn"  @click="validateLoginForm" :disabled="formIsValid  ? false : true" 
                                                :style= "[formIsValid ? {cursor: 'pointer'} : {cursor: 'not-allowed'}]">SIGN IN</button> -->
                      </div>
                    </form>
                  </div>
                </section>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </GroupMasterLayout>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import backgroundUrl from "@/assets/img/profile_banner.png";
import configObject from "@/config";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Profle:: Epump Portal",
  name: "Profile",
  components: {
    GroupMasterLayout,
  },
  data() {
    return {
      backgroundUrl,
      isButtonDisabled: null,
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      formIsValid: null,
      disabled: true,
      oldPassword: null,
      newPassword: "",
      confirmPassword: null,
      response: null,
      showLoader: null,
      showConfirmedBanner: true,
      showConfirmationLoader: null,
      phone: null,
      firstName: null,
      email: null,
      lastName: null,
      emailDisabled: true,
      fnDisabled: true,
      lnDisabled: true,
      phoneDisabled: true,
    };
  },
  computed: {
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.phone = this.userDetails.phone;
    this.firstName = this.userDetails.firstName;
    this.email = this.userDetails.email;
    this.lastName = this.userDetails.lastName;
  },
  methods: {
    activateEamilInput() {
      this.emailDisabled = true;
    },
    activateFNInput() {
      this.fnDisabled = false;
    },
    activateLNInput() {
      this.lnDisabled = false;
    },
    activatePhoneInput() {
      this.phoneDisabled = false;
    },
    changeRoute(routeName, id) {
      this.$router.push({ name: routeName, query: { id: id } });
    },
    validEmail(email) {
      var re =
        /^[a-z][a-zA-Z0-9_.]*(\.[a-zA-Z][a-zA-Z0-9_.]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
      return re.test(email);
    },
    submitPassword() {
      if (!this.oldPassword) {
        this.$toast.open({
          message: this.$t("text.cusProfile.oldPasswordMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.newPassword) {
        this.$toast.open({
          message: this.$t("text.cusProfile.newPasswordMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (
        (this.newPassword.length > 0 && this.newPassword.length < 6) ||
        this.newPassword.length > 100
      ) {
        this.$toast.open({
          message: this.$t("text.cusProfile.newPasswordShort"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.confirmPassword) {
        this.$toast.open({
          message: this.$t("text.cusProfile.confirmPasswordError"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$toast.open({
          message: this.$t("text.cusProfile.passwordsDontMatch"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      let dataToSend = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
      };
      this.isButtonDisabled = true;
      $(".changePassword").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Account/ChangePassword`,
          dataToSend,
          configObject.authConfig()
        )
        .then((response) => {
          $(".changePassword").hide();
          this.isButtonDisabled = false;
          this.response = response;
          this.$toast.open({
            message: this.$t("text.cusProfile.successfullyChanged"),
            type: "success",
            duration: 5000,
          });
        })
        .catch((error) => {
          $(".changePassword").hide();
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
    editForm($event) {
      $event.preventDefault();
      if (!this.firstName) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.lastName) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (this.phone.length < 10 || this.phone.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }

      let dataToSend = {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phone,
        email: this.email,
      };
      this.isButtonDisabled = true;
      $(".edit_loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Account/Update`,
          dataToSend,
          configObject.authConfig()
        )
        .then((response) => {
          $(".edit_loader").hide();
          this.isButtonDisabled = false;
          this.response = response;
          this.userDetails.phone = dataToSend.phoneNumber;
          this.userDetails.firstName = dataToSend.firstName;
          this.userDetails.lastName = dataToSend.lastName;
          this.userDetails.email = dataToSend.email;
          this.fnDisabled = true;
          this.lnDisabled = true;
          this.phoneDisabled = true;
          localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
          this.$toast.open({
            message: this.$t("text.cusProfile.updated"),
            type: "success",
            duration: 5000,
          });
          window.location.reload();
        })
        .catch((error) => {
          $(".edit_loader").hide();
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
    captureEvents($event) {
      if ($event.target.placeholder === this.$t("text.cusProfile.email")) {
        if ($event.target.value === "") {
          this.$refs.email_error.style.display = "block";
          // this.$refs.email_error.innerHTML = "Password field cannot be blank";
          this.$refs.email_div.style.borderBottom = "1px solid red";
          this.formIsValid = false;
        } else {
          if (this.validEmail($event.target.value)) {
            this.$refs.email_error.style.display = "none";
            this.$refs.email_error.innerHTML = "";
            this.$refs.email_div.style.borderBottom =
              "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          } else {
            this.$refs.email_error.style.color = "red";
            this.$refs.email_error.innerHTML = this.$t(
              "text.errors.invalidEmail"
            );
            this.$refs.email_div.style.borderBottom = "1px solid red";
            this.formIsValid = false;
          }
        }
      }
      if ($event.target.placeholder === this.$t("text.cusProfile.firstName")) {
        if ($event.target.value === "") {
          this.$refs.fn_error.style.display = "block";
          // this.$refs.fn_error.innerHTML = "Firstname field cannot be blank";
          this.$refs.fn_error.style.color = "red";
          this.$refs.fn_div.style.borderBottom = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.fn_error.style.display = "none";
          this.$refs.fn_error.innerHTML = "";
          this.$refs.fn_div.style.borderBottom = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if ($event.target.placeholder === this.$t("text.cusProfile.lastName")) {
        if ($event.target.value === "") {
          this.$refs.ln_error.style.display = "block";
          // this.$refs.ln_error.innerHTML = "Lastname field cannot be blank";
          this.$refs.ln_error.style.color = "red";
          this.$refs.ln_error.style.borderBottom = "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.ln_error.style.display = "none";
          this.$refs.ln_error.innerHTML = "";
          this.$refs.ln_error.style.borderBottom = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if (
        $event.target.placeholder === this.$t("text.cusProfile.phoneNumber")
      ) {
        if ($event.target.value === "") {
          this.$refs.phone_error.style.display = "block";
          // this.$refs.phone_error.innerHTML =
          //   "Phone Number field cannot be blank";
          this.$refs.phone_div.style.borderBottom = "1px solid red";
          this.$refs.phone_error.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error.style.display = "block";
            this.$refs.phone_error.style.color = "red";
            this.$refs.phone_div.style.borderBottom = "1px solid red";
            this.$refs.phone_error.innerHTML = this.$t(
              "text.errors.shortPhoneNumber"
            );
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error.style.display = "none";
          this.$refs.phone_div.style.borderBottom =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    captureFormEvents($event) {
      if (
        $event.target.placeholder === this.$t("text.cusProfile.oldPassword")
      ) {
        if ($event.target.value === "") {
          this.$refs.old_password_error_message.style.display = "block";
          // this.$refs.old_password_error_message.innerHTML =
          //   "Password field cannot be blank";
          this.$refs.old_password_input_div.style.borderBottom =
            "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.old_password_error_message.style.display = "none";
          this.$refs.old_password_input_div.style.borderBottom = "none";
        }
      }
      if (
        $event.target.placeholder === this.$t("text.cusProfile.newPassword")
      ) {
        if ($event.target.value === "") {
          this.$refs.new_password_error_message.style.display = "block";
          // this.$refs.new_password_error_message.innerHTML =
          //   "Password field cannot be blank";
          this.$refs.new_password_input_div.style.borderBottom =
            "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.old_password_error_message.style.display = "none";
          if (
            ($event.target.value.length > 0 &&
              $event.target.value.length < 6) ||
            $event.target.value.length > 100
          ) {
            this.$refs.new_password_error_message.style.display = "block";
            this.$refs.new_password_error_message.style.color = "red";
            this.$refs.new_password_error_message.innerHTML = this.$t(
              "text.cusProfile.newPasswordShort"
            );
            this.formIsValid = false;
          } else {
            this.$refs.new_password_error_message.style.display = "none";
            this.$refs.new_password_input_div.style.borderBottom = "none";
          }
        }
      }
      if (
        $event.target.placeholder === this.$t("text.cusProfile.confirmPassword")
      ) {
        if ($event.target.value === "") {
          this.$refs.confirm_password_error_message.style.display = "block";
          // this.$refs.confirm_password_error_message.innerHTML =
          //   "Password field cannot be blank";
          this.$refs.confirm_password_input_div.style.borderBottom =
            "1px solid red";
          this.formIsValid = false;
        } else {
          this.$refs.confirm_password_error_message.style.display = "none";
          if (this.newPassword !== this.confirmPassword) {
            this.$refs.confirm_password_input_div.style.borderBottom =
              "1px solid red";
            this.$refs.confirm_password_error_message.style.display = "block";
            this.$refs.confirm_password_error_message.style.color = "red";
            this.$refs.confirm_password_error_message.innerHTML = this.$t(
              "text.cusProfile.passwordsDontMatch"
            );
          } else {
            this.$refs.confirm_password_error_message.style.display = "none";
            this.$refs.confirm_password_input_div.style.borderBottom = "none";
            this.formIsValid = true;
          }
        }
      }
    },
    validateResetForm($event) {
      $event.preventDefault();

      this.submitPassword();
    },
  },
};
</script>
